import i18n from '@shared/i18n'
import { IParticipant } from '@shared/models/proto/base/participiant'
import { handleUserFullName } from '@shared/utils/helpers/user-name'

import { UserType } from '@protos/user_type_pb'

export const getSenderName = (params: {
  sender?: IParticipant
  isMyMessage?: boolean
}) => {
  const { sender, isMyMessage } = params

  const unknownUser = i18n.global.t('chat.unknownUser')

  if (!sender) {
    return unknownUser
  }

  const isVisitor = sender.type === UserType.VISITOR

  const isPatient = sender.type === UserType.PATIENT

  if ((isPatient || isVisitor) && isMyMessage) {
    return i18n.global.t('chat.you')
  }

  const defaultName = isVisitor ? i18n.global.t('chat.visitor') : unknownUser

  return handleUserFullName(defaultName, sender.firstName, sender.lastName)
}
